import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LocationInterface } from '@stone/interfaces';

interface LocationsState {
  items: LocationInterface[];
  totalCount: number;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: LocationsState = {
  items: [],
  totalCount: 0,
  loading: false,
  saving: false,
  error: null,
};

const locationsSlice = createSlice({
  name: 'stone.locations',
  initialState,
  reducers: {
    fetchLocationsRequest: (state, _action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    fetchLocationsSuccess: (state, action: PayloadAction<{ items: LocationInterface[]; totalCount: number }>) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
      state.loading = false;
    },
    fetchLocationsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveLocationRequest: (state, _action: PayloadAction<LocationInterface>) => {
      state.saving = true;
      state.error = null;
    },
    saveLocationSuccess: (state) => {
      state.saving = false;
    },
    saveLocationFailure: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.error = action.payload;
    },
    deleteLocationRequest: (state, _action: PayloadAction<number>) => {
      state.saving = true;
      state.error = null;
    },
    deleteLocationSuccess: (state) => {
      state.saving = false;
    },
    deleteLocationFailure: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchLocationsRequest,
  fetchLocationsSuccess,
  fetchLocationsFailure,
  saveLocationRequest,
  saveLocationSuccess,
  saveLocationFailure,
  deleteLocationRequest,
  deleteLocationSuccess,
  deleteLocationFailure,
} = locationsSlice.actions;
export default locationsSlice.reducer;
